import React, { useState, useEffect } from "react";
import MainCalculatorsList from "../FoodCalculator/MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Kalkulator Es Krim - Hitung Takaran dan Bahan Es Krim dengan Tepat";
const DESCRIPTION =
  "Kalkulator es krim gratis - hitung takaran dan bahan es krim buatan rumah dengan tepat. Alat canggih untuk menghitung rasio gula, lemak, dan padatan agar mendapatkan tekstur yang sempurna.";
const KEYWORDS =
  "kalkulator es krim, hitung bahan es krim, takaran es krim, kalkulator beku, membuat es krim di rumah, ice cream calculator, gelato calculator";
const OG_URL = "https://do-calculate.com/calculator/id/ice-cream/";

const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Kalkulator Es Krim",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Beranda",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Kalkulator",
        item: "https://do-calculate.com/id/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Kalkulator Es Krim",
        item: OG_URL,
      },
    ],
  },
];

function IceCreamCalculator() {
  const [totalWeight, setTotalWeight] = useState(1000);
  const [fatPercent, setFatPercent] = useState(10);
  const [msnfPercent, setMsnfPercent] = useState(10.5);
  const [sugarPercent, setSugarPercent] = useState(15);
  const [stabilizerPercent, setStabilizerPercent] = useState(0.5);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const calculateIceCream = () => {
    try {
      setError("");
      const weight = parseFloat(totalWeight);
      const fatP = parseFloat(fatPercent);
      const msnfP = parseFloat(msnfPercent);
      const sugarP = parseFloat(sugarPercent);
      const stabP = parseFloat(stabilizerPercent);

      if (weight <= 0 || fatP < 0 || msnfP < 0 || sugarP < 0 || stabP < 0) {
        setError("Masukkan nilai yang valid dan lebih besar dari nol");
        setResult(null);
        return;
      }
      if (fatP + msnfP + sugarP + stabP >= 100) {
        setError("Jumlah persentase bahan padat harus kurang dari 100%");
        setResult(null);
        return;
      }

      const fatWeight = (weight * fatP) / 100;
      const msnfWeight = (weight * msnfP) / 100;
      const sugarWeight = (weight * sugarP) / 100;
      const stabilizerWeight = (weight * stabP) / 100;
      const waterWeight = weight - (fatWeight + msnfWeight + sugarWeight + stabilizerWeight);
      const totalSolids = fatP + msnfP + sugarP + stabP;

      setResult({ fatWeight, msnfWeight, sugarWeight, stabilizerWeight, waterWeight, totalSolids, batchSize: weight });
    } catch (err) {
      setError("Terjadi kesalahan dalam perhitungan. Pastikan Anda memasukkan angka yang valid.");
      setResult(null);
    }
  };

  useEffect(() => { calculateIceCream(); }, [totalWeight, fatPercent, msnfPercent, sugarPercent, stabilizerPercent]);

  const handleClear = () => {
    setTotalWeight(1000);
    setFatPercent(10);
    setMsnfPercent(10.5);
    setSugarPercent(15);
    setStabilizerPercent(0.5);
    setResult(null);
    setError("");
  };

  return (
    <div className="ltr" style={{ direction: "ltr" }}>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} SCHEMA={SCHEMA} />
      <div className="row"><div className="col-12 col-md-8"><FirstAds /></div></div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ padding: "15px", borderRadius: "5px" }}>
            <h1 style={{ fontSize: "22px", margin: 0 }}>Kalkulator Es Krim</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>Kalkulator Es Krim</strong> membantu Anda menyeimbangkan bahan campuran (Mix) untuk mendapatkan tekstur profesional. Kualitas es krim bergantung pada keseimbangan yang tepat antara lemak, gula, dan padatan susu tanpa lemak (MSNF) guna mencegah pembentukan kristal es dan memastikan tekstur yang lembut.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>Input Campuran Es Krim</h2>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 mb-3">
                  <label>Total Jumlah Campuran (gram)</label>
                  <input type="number" className="form-control" value={totalWeight} onChange={(e) => setTotalWeight(e.target.value)} />
                </div>
                <div className="col-sm-12 col-md-6 mb-3">
                  <label>Target Persentase Lemak (%)</label>
                  <input type="number" className="form-control" value={fatPercent} onChange={(e) => setFatPercent(e.target.value)} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-4 mb-3">
                  <label>Persentase Gula (%)</label>
                  <input type="number" className="form-control" value={sugarPercent} onChange={(e) => setSugarPercent(e.target.value)} />
                </div>
                <div className="col-sm-12 col-md-4 mb-3">
                  <label>Persentase MSNF (%)</label>
                  <input type="number" className="form-control" value={msnfPercent} onChange={(e) => setMsnfPercent(e.target.value)} />
                </div>
                <div className="col-sm-12 col-md-4 mb-3">
                  <label>Stabilizer / Emulsifier (%)</label>
                  <input type="number" className="form-control" value={stabilizerPercent} onChange={(e) => setStabilizerPercent(e.target.value)} />
                </div>
              </div>
              <div className="text-center mb-3 mt-4">
                <button onClick={handleClear} className="btn btn-secondary" style={{ fontSize: "16px", padding: "10px 30px" }}>
                  Hapus Data
                </button>
              </div>
              {error && <div className="alert alert-warning" role="alert">{error}</div>}
              {result && (
                <div className="mt-4">
                  <h3 style={{ fontSize: "18px", marginBottom: "15px", textAlign: "center" }}>
                    <strong>Hasil yang Dibutuhkan untuk Resep:</strong>
                  </h3>
                  <div className="mb-3">
                    <table className="table bmi-table" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th className="bmi-header" style={{ textAlign: "center" }}>Bahan</th>
                          <th className="bmi-header" style={{ textAlign: "center" }}>Berat (gram)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td style={{ textAlign: "center" }}>Lemak murni</td><td style={{ textAlign: "center", fontWeight: "bold" }}>{result.fatWeight.toFixed(2)}</td></tr>
                        <tr><td style={{ textAlign: "center" }}>Padatan Susu Tanpa Lemak (MSNF)</td><td style={{ textAlign: "center", fontWeight: "bold" }}>{result.msnfWeight.toFixed(2)}</td></tr>
                        <tr><td style={{ textAlign: "center" }}>Gula</td><td style={{ textAlign: "center", fontWeight: "bold" }}>{result.sugarWeight.toFixed(2)}</td></tr>
                        <tr><td style={{ textAlign: "center" }}>Stabilizer</td><td style={{ textAlign: "center", fontWeight: "bold" }}>{result.stabilizerWeight.toFixed(2)}</td></tr>
                        <tr><td style={{ textAlign: "center" }}>Cairan (Air/Susu cair)</td><td style={{ textAlign: "center", fontWeight: "bold", color: "#1a5f3f" }}>{result.waterWeight.toFixed(2)}</td></tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="info-sections-container">
                    <div className="info-section">
                      <div className="info-section-header">Analisis Tekstur</div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0, lineHeight: "2" }}>
                          <li>🍦 <strong>Total Padatan:</strong> {result.totalSolids.toFixed(2)}%</li>
                          <li>💧 <strong>Persentase Air:</strong> {(100 - result.totalSolids).toFixed(2)}%</li>
                        </ul>
                        <div className="alert alert-info mt-2" style={{ fontSize: "14px" }}>
                          Kisaran ideal total padatan adalah antara 36% dan 42% untuk tekstur terbaik.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <div className="row"><RelatedLinks /></div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds /><br />
          <MainCalculatorsList />
        </div>
      </div>

      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Cara Menggunakan Kalkulator Es Krim</div>
              <div className="info-section-body">
                <p>Untuk membuat es krim yang seimbang, Anda perlu menentukan persentase bahan utama:</p>
                <ul>
                  <li><strong>Lemak:</strong> Memberikan kekayaan rasa pada es krim (kisaran ideal 10-16%).</li>
                  <li><strong>MSNF:</strong> Adalah protein susu, laktosa, dan gula susu, membantu kekentalan tekstur (kisaran ideal 9-11%).</li>
                  <li><strong>Gula:</strong> Menurunkan titik beku dan menambah rasa manis (kisaran ideal 14-18%).</li>
                  <li><strong>Stabilizer:</strong> Mencegah pembentukan kristal es yang besar (kisaran ideal 0.3-0.5%).</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Pentingnya Menyeimbangkan Bahan</div>
              <div className="info-section-body">
                <p>Jika persentase air terlalu tinggi, es krim akan menjadi beku dan keras. Jika persentase lemak terlalu tinggi, bisa meninggalkan rasa berminyak yang tidak diinginkan di lidah. Menggunakan kalkulator memastikan Anda:</p>
                <ol>
                  <li>Menghindari tekstur berpasir (karena kelebihan laktosa).</li>
                  <li>Mendapatkan kecepatan leleh yang tepat.</li>
                  <li>Tekstur krim yang lembut dan mudah disendok.</li>
                </ol>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Tips Profesional untuk Es Krim Rumahan</div>
              <div className="info-section-body">
                <p>Untuk mendapatkan hasil terbaik saat menggunakan kalkulator:</p>
                <ul>
                  <li>Gunakan timbangan digital yang akurat (dalam miligram untuk stabilizer).</li>
                  <li>Pastikan untuk mendinginkan campuran selama 4-12 jam sebelum dimasukkan ke mesin es krim.</li>
                  <li>Pastikan total padatan tidak melebihi 42% untuk menghindari tekstur yang terlalu berat.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IceCreamCalculator;